import * as React from 'react';
import { FC } from 'react';
import { ToggleButton } from '@mui/material';

import { Environment } from '@playq/octopus-common';

import { IEnvToggleButtonProps } from './types';
import { ToggleButtonGroupStyled } from './styles';

export const EnvToggleButton: FC<IEnvToggleButtonProps> = ({ env = Environment.Live, handleEnvChange, ...rest }) => {
  const handleChange = (event: React.MouseEvent<HTMLElement>, value: unknown) => {
    if (value !== null) {
      handleEnvChange(event, value as Environment);
    }
  };

  return (
    <ToggleButtonGroupStyled
      {...rest}
      $env={env}
      value={env}
      exclusive
      onChange={handleChange}
      data-testid={env}
      aria-label='env'
    >
      <ToggleButton value={Environment.Sandbox}>{Environment.Sandbox}</ToggleButton>
      <ToggleButton value={Environment.Live}>{Environment.Live}</ToggleButton>
    </ToggleButtonGroupStyled>
  );
};
